import { withReferral } from "./withReferral";

/**
 * Beat-my-score challenge links for web games.
 *
 * A challenge link preloads the game with a score to beat:
 *   https://www.pixleyai.com/games/bubble-pop?challenge=42&ref=<sharerId>
 */

/** Sanitize an incoming ?challenge= value to a playable target (1..99999). */
export function parseChallengeScore(raw) {
  const n = Number.parseInt(raw ?? "", 10);
  if (!Number.isFinite(n) || n < 1 || n > 99999) return null;
  return n;
}

/**
 * Build an outgoing challenge link for the CURRENT player's score.
 * ref carries the sharer's own id when signed in and is omitted for guests —
 * a guest must never forward someone else's referral.
 */
export function buildChallengeLink(gamePath, score, userId) {
  const base = `https://www.pixleyai.com${gamePath}?challenge=${score}`;
  return userId ? withReferral(base, userId) : base;
}
